<template>
  <div>
    <v-row>
      <v-col
        cols="12"
        md="5"
        lg="4"
      >
        <colaborador-bio-panel
          :key="colaborador.id"
          :acesso-put="acessoPut"
          :colaborador-data="colaborador"
        ></colaborador-bio-panel>
      </v-col>

      <v-col
        cols="12"
        md="7"
        lg="8"
      >
        <v-tabs
          v-model="userTab"
          show-arrows
          grow
          class="user-tabs"
        >
          <v-tab
            v-for="tab in tabs"
            :key="tab.icon"
            @click="getColaborador"
          >
            <v-icon
              size="20"
              class="me-3"
            >
              {{ tab.icon }}
            </v-icon>
            <span>{{ tab.title }}</span>
          </v-tab>

          <v-tab
            :to="{ name: 'colaboradores' }"
          >
            <v-icon
              color="error"
            >
              {{ icons.mdiCloseCircleOutline }}
            </v-icon>
          </v-tab>
        </v-tabs>

        <v-tabs-items
          id="user-tabs-content"
          v-model="userTab"
          class="mt-5 pa-1"
        >
          <v-tab-item>
            <colaborador-tab-security
              :key="colaborador.id"
              :acesso-put="acessoPut"
              :security-data="colaborador"
            ></colaborador-tab-security>
          </v-tab-item>

          <v-tab-item>
            <colaborador-tab-connections
              :key="colaborador.id"
              :acesso-put="acessoPut"
              :connections-data="colaborador"
            >
            </colaborador-tab-connections>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {
  mdiLinkVariant, mdiLockOutline, mdiCloseCircleOutline,
} from '@mdi/js'
import { ref } from '@vue/composition-api'
import { mapState } from 'pinia'
import router from '@/router'

import ColaboradorBioPanel from '@/views/colaborador/colaborador-bio-panel/ColaboradorBioPanel.vue'
import ColaboradorTabConnections from '@/views/colaborador/colaborador-tab-connections/ColaboradorTabConnections.vue'

import ColaboradorTabSecurity from '@/views/colaborador/colaborador-tab-security/ColaboradorTabSecurity.vue'
import useAuthStore from '@/store/auth'
import ColaboradorService from '@/services/modules/ColaboradorService'

export default {
  components: {
    ColaboradorBioPanel,
    ColaboradorTabSecurity,
    ColaboradorTabConnections,
  },

  data() {
    return {
      colaborador: {},
      idPut: 1019,
      acessoPut: true,
      idAssociacao: 1064,
      acessoAssociacao: true,
    }
  },

  computed: {
    ...mapState(useAuthStore, ['funcionalidades']),
  },

  mounted() {
    this.getColaborador()
    // this.permissoes()
  },

  methods: {
    permissoes() {
      if (!this.funcionalidades.includes(this.idPut)) {
        this.acessoPut = false
      }
      if (!this.funcionalidades.includes(this.idAssociacao)) {
        this.acessoAssociacao = false
      }
    },

    async getColaborador() {
      this.colaborador = await ColaboradorService.getById(router.currentRoute.params.id)
    },
  },

  setup() {
    const userData = ref({})
    const userTab = ref('')

    const tabs = [
      { icon: mdiLockOutline, title: 'Segurança' },
      { icon: mdiLinkVariant, title: 'Dados de contato' },
    ]

    return {
      tabs,
      userTab,
      userData,
      icons: {
        mdiCloseCircleOutline,
      },
    }
  },
}
</script>

<style lang="scss">
@import '@core/preset/preset/apps/user.scss';
</style>
